export default __webpack_public_path__ + "static/media/Sandusky.dadca612.jpg";